import { getLogger } from "loglevel";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { CbmImpl } from "~/modules/cbm";
import { LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { getReservationsByTask, sendTrackingEvent } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { FlexSdkError, ErrorCode, ErrorSeverity } from "~/modules/error";
import { Action } from "~/modules/actions/Action";




















export class KickParticipant implements Action<Promise<void>> {
    


    #targetParticipantSid: string;

    


    #taskSid: string;

    constructor(targetParticipantSid: string, taskSid: string) {
        this.#targetParticipantSid = targetParticipantSid;
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.getInstanceOf(TaskRouterImpl);
        const logger = getLogger(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.getInstanceOf(AnalyticsImpl);
        const cbm = context.getInstanceOf(CbmImpl);

        logger.debug(`kickParticipant invoked with #taskSid: ${this.#taskSid}`);

        if (!cbm) {
            const errorMsg = "kickParticipant: CBM SDK is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        if (!worker) {
            const errorMsg = "kickParticipant: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations?.find((res) => res.status === "accepted");
        if (!reservation) {
            const errorMsg = `kickParticipant: Reservation for task ${this.#taskSid} not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.KickParticipantCompleted, analytics, worker, errorMsg);
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }

        const task = reservation.task;

        const participants = await cbm.getParticipantsByTask(task);
        const workerParticipant = participants.find(
            (p) => p.routingProperties?.workerSid === this.#targetParticipantSid
        );

        if (workerParticipant && worker.sid === this.#targetParticipantSid) {
            const errorMsg = `kickParticipant: Worker ${this.#targetParticipantSid} cannot kick self from task ${
                this.#taskSid
            }`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.KickParticipantCompleted, analytics, worker, errorMsg);
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }

        let customerParticipant;
        if (workerParticipant?.routingProperties?.workerSid !== this.#targetParticipantSid) {
            customerParticipant = await cbm.getParticipantBySid(this.#targetParticipantSid, task);
        }

        if (!customerParticipant && workerParticipant?.routingProperties?.workerSid !== this.#targetParticipantSid) {
            const errorMsg = `kickParticipant: Participant ${this.#targetParticipantSid} for task ${
                this.#taskSid
            } not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.KickParticipantCompleted, analytics, worker, errorMsg);
            throw new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg);
        }

        try {
            if (customerParticipant && customerParticipant.type === "external") {
                await cbm.removeVoiceParticipant(task, customerParticipant.participantSid);
                sendTrackingEvent(EVENTS.KickParticipantCompleted, analytics, worker);
                return Promise.resolve();
            }

            await task.kick(this.#targetParticipantSid);
            sendTrackingEvent(EVENTS.KickParticipantCompleted, analytics, worker);
            return Promise.resolve();
        } catch (e) {
            const errorMsg = `kickParticipant: Failed to kick participant ${this.#targetParticipantSid} \
        from reservation ${reservation.sid}`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.KickParticipantCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
